/**
 * ConsoleReturnPill — when a page is opened from the Suite Console
 * (?from=console), show a fixed "back to Suite Console" pill on every
 * page until the user returns or dismisses it.
 */
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LayoutGrid, X } from "lucide-react";

const KEY = "hs-console-return";

export default function ConsoleReturnPill() {
  const location = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const params = new URLSearchParams(location.search);
      if (params.get("from") === "console") sessionStorage.setItem(KEY, "1");
      if (location.pathname === "/agency/settings") sessionStorage.removeItem(KEY);
      setShow(sessionStorage.getItem(KEY) === "1" &&
              location.pathname !== "/agency/settings");
    } catch { setShow(false); }
  }, [location]);

  if (!show) return null;
  return (
    <div data-testid="console-return-pill"
      style={{ position: "fixed", bottom: 18, left: 18, zIndex: 9999,
        display: "flex", alignItems: "center", gap: 4 }}>
      <button type="button"
        data-testid="console-return-btn"
        onClick={() => { try { sessionStorage.removeItem(KEY); } catch { /* noop */ } navigate("/agency/settings"); }}
        style={{ display: "inline-flex", alignItems: "center", gap: 8,
          background: "#1B1F1C", color: "#FDFBF7", border: "none",
          borderRadius: 999, padding: "10px 18px", fontSize: 13,
          fontWeight: 600, cursor: "pointer", boxShadow: "0 4px 14px rgba(0,0,0,0.25)" }}>
        <LayoutGrid size={14} /> Suite Console
      </button>
      <button type="button" aria-label="Dismiss"
        data-testid="console-return-dismiss"
        onClick={() => { try { sessionStorage.removeItem(KEY); } catch { /* noop */ } setShow(false); }}
        style={{ display: "inline-flex", alignItems: "center", justifyContent: "center",
          background: "#1B1F1C", color: "#FDFBF7", border: "none",
          borderRadius: "50%", width: 26, height: 26, cursor: "pointer",
          boxShadow: "0 4px 14px rgba(0,0,0,0.25)" }}>
        <X size={12} />
      </button>
    </div>
  );
}
